export default "__VITE_ASSET__CFlMUtiP__"